<template>
    <div class="container-fluid d-flex flex-column">
        <div class="row justify-content-center min-vh-100">
            <div class="col-md-6 col-lg-5 col-xl-4 py-6 py-md-0 mt-5">
                <div class="card" style="max-width: 600px; margin: 0 auto;">
                    <div class="d-flex justify-content-end mr-2 mt-1">
                        <LanguageSwitcher />
                    </div>

                    <div class="card-body">
                        <div class="card-header"></div>
                        <div>
                            <div class="mb-5 text-center">
                                <CompanyImage :type="CompanyImageType.Logo" max-height="140px" max-width="100%" />
                            </div>

                            <span class="clearfix"></span>

                            <div v-if="successMessage" class="alert alert-success">
                                {{ successMessage }}
                            </div>

                            <LoginForm
                                :initial-values="request"
                                id="login-form"
                                @submit="submitLogin"
                                @clear-error="errormessage = null"
                            />
                            <div class="mt-4">
                                <button type="submit" form="login-form" class="btn btn-block btn-primary">
                                    {{ $t('register.login_button') }}
                                </button>
                            </div>
                            <div class="mt-3 text-center">
                                <router-link v-if="isLiteVersion" to="/register">{{ $t('register.register_link') }}</router-link>
                                <a v-if="!isLiteVersion" href="#" @click="showNonLiteRegisterInfo = true">{{ $t('register.register_link') }}</a>
                                |
                                <router-link to="/forgot-password">{{ $t('register.forgot_password_link') }}</router-link>
                            </div>
                            <div class="alert alert-danger mt-5" v-if="errors.length">
                                <ul>
                                    <li v-for="(error, index) in errors" :key="index">{{ error }}</li>
                                </ul>
                            </div>
                            <div class="alert alert-danger mt-5" v-if="errormessage">
                                {{ errormessage }}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <Modal :show="showNonLiteRegisterInfo" @close="showNonLiteRegisterInfo = false" :custom_modal_class="'modal-xs fullwidth-modal'">
            <div slot="header">
                <div class="modal-header">
                    <h5 class="modal-title">{{ $t('register.register_title') }}</h5>
                    <button type="button" class="close" @click="showNonLiteRegisterInfo = false" aria-label="Close"><span aria-hidden="true">×</span></button>
                </div>
            </div>

            <div slot="body">
                {{ $t('register.already_a_account_pre_notify_normal') }}
            </div>

            <div slot="footer">
                <button type="button" class="btn btn-secondary btn-sm" data-dismiss="modal" @click="showNonLiteRegisterInfo = false">{{ $t('general.close') }}</button>
            </div>
        </Modal>
    </div>
</template>


<script>
    import LoginForm from '../forms/LoginForm.vue';
    import LanguageSwitcher from '../components/LanguageSwitcher.vue';
    import { mapGetters } from 'vuex';
    import Modal from '../components/Modal.vue';
    import CompanyImage from './CompanyImage.vue';
    import { CompanyImageType } from '../enums/company-image-type';

    export default {
        components: {
            CompanyImage,
            Modal,
            LanguageSwitcher,
            LoginForm,
        },
        data() {
            return {
                request: {
                    email: null,
                    password: null,
                    remember: false,
                },
                errormessage: null,
                errors: [],
                showNonLiteRegisterInfo: false,
            };
        },
        computed: {
            CompanyImageType() {
                return CompanyImageType;
            },
            isLiteVersion() {
                return window.IS_LITE_VERSION;
            },
            successMessage() {
                if (Object.hasOwn(this.$route.query, 'deleted_account')) {
                    return this.$t('account.delete_account_success');
                }

                return null;
            },
            ...mapGetters(['hasPermission']),
        },
        methods: {
            async submitLogin(data) {
                try {
                    const { email, password, remember } = data;

                    const response = await this.$http.post('/api/login', {
                        email,
                        password,
                        remember,
                    });

                    await this.$store.dispatch('login', {
                        user: response.data.user,
                        token: response.data.token,
                    });

                    await this.$store.dispatch('setLocations', response.data.user.company?.locations || []);

                    if (this.hasPermission('viewCeremonies')) {
                        await this.$router.push('/');
                    } else if (this.hasPermission('manageSongs')) {
                        await this.$router.push('/songs');
                    }
                } catch (exception) {
                    this.handleErrorResponse(exception.response);
                }
            },
            handleErrorResponse(response) {
                if (response.status === 401) {
                    this.errormessage = this.$t('register.unauthorized_error');
                } else if (response.status === 422) {
                    this.errors = Object.values(response.data.errors).flat();
                } else {
                    this.errormessage = this.$t('general.unexpected_error');
                }
            },
        },
    };
</script>
